import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';
import { ZIndex } from 'styles/zIndex';
import { Button } from 'src/components/common/buttons/Button';
import { GREY_1, GREY_3, WHITE } from 'styles/colors';
import { BasicButton } from 'src/components/common/buttons/BasicButton';
import { ModalDuration } from 'src/constants/modal';

interface ModalContainerParams {
  isShow: boolean;
}

export const Title = styled.h2`
  font-size: 16px;
  line-height: 19px;
`;

export const CloseButton = styled(Button)`
  width: 24px;
  height: 24px;
  margin: 0 0 0 auto;
`;

export const IconWrapper = styled.div`
  width: 17px;
  height: 17px;
`;

export const ModalHead = styled.div`
  box-sizing: border-box;
  background: ${WHITE};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  height: 58px;
  z-index: ${ZIndex.ModalContent};
  box-shadow: 0px 7px 12px rgba(231, 231, 231, 0.3);
`;

export const ModalButtons = styled.div`
  display: flex;
  overflow: hidden;
  align-self: flex-end;
  justify-self: flex-end;
  width: 100%;
  height: 100%;
  padding: 38px 24px;
  button {
    display: inline-block;
  }

  button + button {
    margin-left: 4px;
  }
`;

export const ModalBottom = styled.div`
  box-sizing: border-box;
  background: ${WHITE};
  height: 92px;
  min-height: 92px;
  z-index: ${ZIndex.ModalContent};
`;

export const RejectButton = styled(BasicButton)`
  border: 1px solid ${GREY_3};
  color: ${GREY_1};
  background-color: ${WHITE};
  margin-right: 8px;
  font-weight: normal;
  border-radius: 5px;
`;

export const ModalContent = styled.div`
  background: ${WHITE};
  height: 100%;
`;

export const ModalContainer = styled.div(
  ({ isShow }: ModalContainerParams) => css`
    display: flex;
    position: absolute;
    flex-direction: column;
    right: 0;
    width: 500px;
    height: 796px;
    border-radius: 10px 10px 0px 0px;
    z-index: ${ZIndex.ModalContent};
    overflow: hidden;
    top: 184px;
    filter: drop-shadow(-10px 10px 20px rgba(0, 0, 0, 0.08));

    ${!isShow
      ? css`
          animation: ${ModalDuration.Slide}ms ${slideOut} forwards;
        `
      : css`
          animation: ${ModalDuration.Slide}ms ${slideIn};
        `};
  `,
);

const slideIn = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
`;

const slideOut = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
`;
